import { ProductTypeDto } from 'src/store/producttypes/producttype';
import { ArrayUtils } from 'src/utils/array';
import { ProductTypeAction, ProductTypeTypes } from './producttypes.actions';

export type ProductTypesState = Readonly<{
  productTypes: ProductTypeDto[];
  errors: any;
}>;

const initialState: ProductTypesState = {
  productTypes: [],
  errors: null
};

const productTypesReducer = (
  state: ProductTypesState = initialState,
  action: ProductTypeAction
) => {
  switch (action.type) {
    case ProductTypeTypes.FetchAll:
      return { ...state, productTypes: action.productTypes };
    case ProductTypeTypes.Add:
      return {
        ...state,
        productTypes: [...state.productTypes, action.productType]
      };
    case ProductTypeTypes.Update:
      return {
        ...state,
        productTypes: ArrayUtils.updateListById(
          state.productTypes,
          action.productType
        )
      };
    case ProductTypeTypes.Delete:
      return {
        ...state,
        productType: null,
        productTypes: ArrayUtils.deleteFromListById(
          state.productTypes,
          action.productType
        )
      };
    case ProductTypeTypes.Failure:
      return { ...state, errors: action.errors };
    default:
      return state;
  }
};

export default productTypesReducer;
